import { render, staticRenderFns } from "./AttendencePlacesInformations.vue?vue&type=template&id=3990457c"
import script from "./AttendencePlacesInformations.vue?vue&type=script&lang=js"
export * from "./AttendencePlacesInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports